import { useMediaQuery, useTheme } from '@mui/material'

/** Celular (abaixo do breakpoint `sm` do tema, 600px): diálogos em tela cheia, botão flutuante etc. */
export default function useTelaPequena() {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.down('sm'))
}
